module.exports = __webpack_public_path__ + "static/media/good.8f6c29a4.svg";